import { render } from "./InsulinModal.vue?vue&type=template&id=04f58b50"
import script from "./InsulinModal.vue?vue&type=script&lang=js"
export * from "./InsulinModal.vue?vue&type=script&lang=js"

import "./InsulinModal.vue?vue&type=style&index=0&id=04f58b50&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__